import { render, staticRenderFns } from "./hbtEcg.vue?vue&type=template&id=c778bb9a&scoped=true&"
import script from "./hbtEcg.vue?vue&type=script&lang=js&"
export * from "./hbtEcg.vue?vue&type=script&lang=js&"
import style0 from "./hbtEcg.vue?vue&type=style&index=0&id=c778bb9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c778bb9a",
  null
  
)

export default component.exports